



























import { bookModelProvider } from '../model'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'

export default defineClassComponent(
  () =>
    class {
      bookModel = bookModelProvider.inject()

      handleFavoriteClick = () => {
        this.bookModel.value.toggleFavorite()
      }

      handleShareClick = () => {
        dcb.share({
          ...this.bookModel.value.shareParams,
          url: location.href,
        })
      }
    },
)
